import type { TranslationKey } from "./en";

const ar: Partial<Record<TranslationKey, string>> = {
  "lang.label": "اللغة",
  "lang.select": "اختر اللغة",
  "theme.toggle": "تبديل المظهر",
  "theme.light": "الوضع الفاتح",
  "theme.dark": "الوضع الداكن",
  "brand.name": "GuardAI من G-Data Labs",
  "brand.short": "GuardAI",
  "brand.subtitle": "الدوريات الأمنية",
  "brand.guardSystem": "نظام الحراسة",
  "console.director": "وحدة تحكم المدير",
  "console.admin": "وحدة تحكم المسؤول",
  "console.supervisor": "وحدة تحكم المشرف",
  "role.administrator": "مسؤول النظام",
  "role.director": "المدير",
  "role.supervisor": "المشرف",
  "role.guard": "حارس الأمن",
  "nav.dashboard": "لوحة التحكم",
  "nav.liveActivity": "النشاط المباشر",
  "nav.devices": "الأجهزة",
  "nav.schedules": "الجداول",
  "nav.calendar": "التقويم",
  "nav.alerts": "التنبيهات",
  "nav.checkpoints": "نقاط التفتيش",
  "nav.reports": "التقارير",
  "nav.reportBuilder": "منشئ التقارير",
  "nav.askAi": "اسأل الذكاء الاصطناعي",
  "nav.admin": "الإدارة",
  "nav.settings": "الإعدادات",
  "nav.deploy": "النشر",
  "nav.scanMap": "خريطة المسح",
  "nav.users": "إدارة المستخدمين",
  "common.save": "حفظ",
  "common.cancel": "إلغاء",
  "common.submit": "إرسال",
  "common.delete": "حذف",
  "common.edit": "تعديل",
  "common.search": "بحث",
  "common.filter": "تصفية",
  "common.export": "تصدير",
  "common.clear": "مسح",
  "common.viewAll": "عرض الكل",
  "common.back": "رجوع",
  "common.close": "إغلاق",
  "common.confirm": "تأكيد",
  "common.add": "إضافة",
  "common.refresh": "تحديث",
  "common.loading": "جارٍ التحميل…",
  "common.saving": "جارٍ الحفظ…",
  "common.saved": "تم الحفظ",
  "common.error": "خطأ",
  "common.noData": "لا توجد بيانات",
  "common.required": "مطلوب",
  "common.optional": "اختياري",
  "common.yes": "نعم",
  "common.no": "لا",
  "common.all": "الكل",
  "common.none": "لا شيء",
  "common.name": "الاسم",
  "common.status": "الحالة",
  "common.location": "الموقع",
  "common.time": "الوقت",
  "common.date": "التاريخ",
  "common.actions": "الإجراءات",
  "common.today": "اليوم",
  "domain.scanEvent": "حدث مسح",
  "domain.scanEvents": "أحداث المسح",
  "domain.checkpoint": "نقطة تفتيش",
  "domain.checkpoints": "نقاط التفتيش",
  "domain.hospital": "مستشفى",
  "domain.hospitals": "المستشفيات",
  "domain.guard": "حارس",
  "domain.guards": "الحراس",
  "domain.device": "جهاز",
  "domain.devices": "الأجهزة",
  "domain.patrol": "دورية",
  "domain.security": "الأمن",
  "domain.shift": "وردية",
  "domain.station": "محطة",
  "search.placeholder": "ابحث عن الحراس أو المواقع أو عمليات المسح…",
  "notif.title": "الإشعارات",
  "notif.empty": "لا توجد إشعارات جديدة",
  "notif.viewAll": "عرض جميع الإشعارات",
  "notif.missedCheckpoint": "تنبيه نقطة تفتيش فائتة",
  "status.active": "نشط",
  "status.inactive": "غير نشط",
  "status.online": "متصل",
  "status.offline": "غير متصل",
  "status.pending": "قيد الانتظار",
  "status.approved": "موافق عليه",
  "status.denied": "مرفوض",
  "status.flagged": "مُعلَّم",
  "status.completed": "مكتمل",
  "status.missed": "فائت",
  "status.onDuty": "في الخدمة",
  "status.offDuty": "خارج الخدمة",
  "auth.signIn": "تسجيل الدخول",
  "auth.signingIn": "جارٍ تسجيل الدخول…",
  "auth.signOut": "تسجيل الخروج",
  "auth.username": "اسم المستخدم",
  "auth.password": "كلمة المرور",
  "auth.loginFailed": "فشل تسجيل الدخول",
  "auth.tagline": "يقوم حراس الأمن بمسح بطاقاتهم في أي محطة، ويرى المشرفون التحديثات فورًا على لوحة تحكم آمنة.",
  "dashboard.title": "مركز الدوريات الأمنية",
  "dashboard.subtitle": "مراقبة فورية عبر جميع نقاط التفتيش",
  "dashboard.totalScans": "إجمالي عمليات المسح",
  "dashboard.activeGuards": "الحراس النشطون",
  "dashboard.checkpoints": "نقاط التفتيش",
  "dashboard.openAlerts": "التنبيهات المفتوحة",
  "dashboard.recentActivity": "النشاط الأخير",
  "dashboard.noActivity": "لا يوجد نشاط حديث",
  "live.title": "نشاط الدوريات المباشر",
  "live.subtitle": "بث فوري لكل عملية مسح بطاقة فور حدوثها",
  "live.empty": "لا يوجد نشاط بعد",
  "live.waiting": "في انتظار عملية المسح التالية…",
  "devices.title": "أجهزة الدوريات المتصلة",
  "devices.subtitle": "حالة كل جهاز مسح في الميدان",
  "devices.lastSeen": "آخر ظهور",
  "devices.battery": "البطارية",
  "devices.none": "لا توجد أجهزة متصلة",
  "schedules.title": "جداول الدوريات",
  "schedules.subtitle": "تعيين الحراس على الورديات ونقاط التفتيش",
  "schedules.addShift": "إضافة وردية",
  "schedules.none": "لا توجد جداول بعد",
  "alerts.title": "التنبيهات الأمنية",
  "alerts.subtitle": "نقاط التفتيش الفائتة والأحداث المُعلَّمة التي تتطلب الانتباه",
  "alerts.none": "لا توجد تنبيهات نشطة",
  "alerts.allClear": "كل شيء على ما يرام — لا شيء يتطلب الانتباه.",
  "alerts.acknowledge": "إقرار",
  "alerts.resolve": "حل",
  "reports.title": "التقارير الأمنية",
  "reports.subtitle": "تغطية الدوريات وحجم المسح وتحليلات النزاهة",
  "reports.builderTitle": "منشئ التقارير",
  "reports.builderSubtitle": "صمّم تقارير احترافية — دون الحاجة إلى برمجة.",
  "reports.generate": "إنشاء التقرير",
  "reports.noData": "لا توجد بيانات لهذا التقرير",
  "ask.title": "اسأل الذكاء الاصطناعي",
  "ask.greeting": "كيف يمكنني مساعدتك اليوم؟",
  "ask.placeholder": "اسأل عن أي شيء يتعلق بدورياتك أو حراسك أو عمليات المسح…",
  "ask.send": "إرسال",
  "ask.thinking": "جارٍ التفكير…",
  "admin.title": "إدارة النظام",
  "admin.subtitle": "إدارة الوصول والموافقات وصحة النظام",
  "admin.pendingApplications": "الطلبات المعلقة",
  "admin.systemHealth": "صحة النظام",
  "admin.uptime": "مدة التشغيل",
  "admin.storage": "التخزين",
  "admin.users": "المستخدمون",
  "admin.latency": "زمن الاستجابة",
  "users.title": "إدارة المستخدمين",
  "users.subtitle": "إضافة حسابات المنصة وتعديلها وإلغاء تنشيطها",
  "users.addUser": "إضافة مستخدم",
  "users.none": "لم يتم العثور على مستخدمين",
  "settings.title": "الإعدادات",
  "settings.subtitle": "إدارة حسابك وتفضيلاتك",
  "settings.account": "الحساب",
  "settings.appearance": "المظهر",
  "settings.notifications": "الإشعارات",
  "settings.language": "اللغة",
  "deploy.title": "مخطط النشر",
  "deploy.subtitle": "تخطيط مواضع نقاط التفتيش والتقاطها والتحقق منها",
  "deploy.plan": "التخطيط",
  "deploy.capture": "الالتقاط",
  "deploy.verify": "التحقق",
  "map.title": "خريطة المسح",
  "map.subtitle": "أماكن حدوث عمليات مسح البطاقات عبر المنشأة",
  "map.noScans": "لا توجد عمليات مسح لعرضها",
  "profile.account": "الحساب",
  "profile.settings": "الإعدادات",
  "profile.help": "المساعدة والدعم",
  "profile.darkMode": "الوضع الداكن",
  "profile.viewProfile": "عرض الملف الشخصي",
  "footer.copyright": "© 2026 G-Data Labs. جميع الحقوق محفوظة.",
  "footer.terms": "شروط الاستخدام",
  "footer.privacy": "سياسة الخصوصية",
  // ── Auto-added: full dashboard content translations ──
  "admin.addGuard": "إضافة حارس",
  "admin.addNewGuard": "إضافة حارس جديد",
  "admin.addRoute": "إضافة مسار",
  "admin.alertEmail": "البريد الإلكتروني لإشعارات التنبيهات",
  "admin.avgResponse": "متوسط الاستجابة",
  "admin.checkpointTimeout": "مهلة نقطة التفتيش (دقائق)",
  "admin.checkpointsCount": "نقاط التفتيش ({n})",
  "admin.colBadge": "البطاقة",
  "admin.colContact": "جهة الاتصال",
  "admin.colGuard": "حارس",
  "admin.colLastActive": "آخر نشاط",
  "admin.colRole": "الدور",
  "admin.colRoutes": "المسارات",
  "admin.deactivatedPreviewDesc": "هكذا يظهر الحساب المعطّل للمسؤولين.",
  "admin.deactivatedPreviewTitle": "معاينة حارس معطّل",
  "admin.difficultyEasy": "سهل",
  "admin.difficultyHard": "صعب",
  "admin.difficultyMedium": "متوسط",
  "admin.employeeId": "معرّف الموظف:",
  "admin.errorAddGuard": "تعذّرت إضافة الحارس. يرجى المحاولة مرة أخرى.",
  "admin.errorAllFields": "جميع الحقول مطلوبة.",
  "admin.errorLoadDirectory": "تعذّر تحميل دليل الحراس في الوقت الحالي.",
  "admin.fieldEmail": "البريد الإلكتروني",
  "admin.fieldEmergencyContact": "جهة اتصال الطوارئ",
  "admin.fieldEmployeeId": "معرّف موظف Emory",
  "admin.fieldFullName": "الاسم الكامل",
  "admin.fieldPhone": "الهاتف",
  "admin.fieldRole": "الدور",
  "admin.fieldTempPassword": "كلمة مرور مؤقتة",
  "admin.gpsThreshold": "حدّ دقة نظام تحديد المواقع (أمتار)",
  "admin.guardId": "معرّف الحارس:",
  "admin.loadingDirectory": "جارٍ تحميل دليل الحراس…",
  "admin.moreCheckpoints": "+{n} نقاط تفتيش أخرى",
  "admin.noGuards": "لم يتم العثور على حراس. أضف أول حارس للبدء.",
  "admin.noRoutesAssigned": "لا توجد مسارات مخصّصة",
  "admin.notGenerated": "لم تُنشأ",
  "admin.passwordPolicy": "سياسة كلمات المرور",
  "admin.passwordPolicyDesc": "فرض كلمات مرور قوية",
  "admin.patrolRoutes": "مسارات الدوريات",
  "admin.placeholderTempPassword": "عيّن كلمة مرور مؤقتة",
  "admin.resetSessions": "إعادة تعيين جميع الجلسات",
  "admin.roleAdmin": "مسؤول",
  "admin.roleDirector": "مدير",
  "admin.roleGuard": "حارس",
  "admin.roleSupervisor": "مشرف",
  "admin.saveConfiguration": "حفظ التكوين",
  "admin.searchGuards": "البحث عن الحراس...",
  "admin.securitySettings": "إعدادات الأمان",
  "admin.sessionTimeout": "مهلة انتهاء الجلسة",
  "admin.sessionTimeoutDesc": "تسجيل الخروج تلقائيًا بعد عدم النشاط",
  "admin.statusDeactivated": "معطّل",
  "admin.statusLabel": "الحالة:",
  "admin.statusSuspended": "موقوف",
  "admin.storageUsed": "التخزين المستخدم",
  "admin.systemConfiguration": "تكوين النظام",
  "admin.systemStatus": "حالة النظام",
  "admin.tabBadges": "مولّد البطاقات",
  "admin.tabGuards": "إدارة الحراس",
  "admin.tabRoutes": "إدارة المسارات",
  "admin.tabSettings": "إعدادات النظام",
  "admin.timeout1Hour": "ساعة واحدة",
  "admin.timeout2Hours": "ساعتان",
  "admin.timeout30Min": "30 دقيقة",
  "admin.timeout4Hours": "4 ساعات",
  "admin.totalScans": "إجمالي عمليات المسح",
  "admin.twoFactor": "المصادقة الثنائية",
  "admin.twoFactorDesc": "اشتراط المصادقة الثنائية لجميع المشرفين",
  "admin.viewBadge": "عرض البطاقة",
  "alerts.acknowledged": "تم الإقرار",
  "alerts.activeAlerts": "التنبيهات النشطة",
  "alerts.allLocationsHealthy": "جميع المواقع سليمة",
  "alerts.allPriorities": "جميع الأولويات",
  "alerts.allStatus": "جميع الحالات",
  "alerts.allTypes": "جميع الأنواع",
  "alerts.apiError": "خطأ في واجهة برمجة التطبيقات",
  "alerts.assignedTo": "مُسند إلى:",
  "alerts.critical": "حرجة",
  "alerts.distanceAway": "على بُعد {n} م",
  "alerts.exportTitle": "تصدير بيانات التنبيهات",
  "alerts.filters": "عوامل التصفية",
  "alerts.guardLabel": "الحارس {name}",
  "alerts.high": "عالية",
  "alerts.invalidScan": "مسح غير صالح",
  "alerts.issuesDetected": "تم اكتشاف {n} مشكلة",
  "alerts.loadFailed": "فشل تحميل التنبيهات",
  "alerts.loadFailedHint": "تحقق من أن نقطة نهاية التنبيهات قد تم نشرها.",
  "alerts.loadingAlerts": "جارٍ تحميل التنبيهات...",
  "alerts.low": "منخفضة",
  "alerts.medium": "متوسطة",
  "alerts.noInvalidScans": "لا توجد عمليات مسح غير صالحة في الدفعة الأخيرة.",
  "alerts.noneMatchFilters": "لم يتم العثور على تنبيهات مطابقة لعوامل التصفية",
  "alerts.refreshTitle": "تحديث التنبيهات",
  "alerts.resolved": "تم الحل",
  "alerts.scanExceptions": "استثناءات مسح الدوريات",
  "alerts.scanExceptionsSubtitle": "عمليات مسح غير صالحة أو أخطاء واجهة برمجة التطبيقات الواردة من أجهزة الميدان",
  "alerts.tryAgain": "أعد المحاولة",
  "alerts.typeEmergency": "طوارئ",
  "alerts.typeMissedCheckpoint": "نقطة تفتيش فائتة",
  "alerts.typeSystem": "النظام",
  "alerts.unknownGuard": "غير معروف",
  "ask.accessDenied": "تم رفض الوصول",
  "ask.accessDeniedDesc": "ميزة سؤال الذكاء الاصطناعي مقتصرة على المسؤولين.",
  "ask.askNow": "اسأل الآن",
  "ask.askedTimesOne": "سُئل {n} مرة",
  "ask.askedTimesOther": "سُئل {n} مرات",
  "ask.closeHistory": "إغلاق السجل",
  "ask.dateAtTime": "{date} الساعة {time}",
  "ask.encryptedPrivate": "تحليل مُشفَّر وخاص",
  "ask.errorMessage": "عذراً، لم أتمكّن من معالجة هذا السؤال. قد يكون السبب مشكلة في الاتصال أو استعلاماً غير مدعوم. يُرجى إعادة صياغة سؤالك أو المحاولة مرة أخرى بعد قليل.",
  "ask.exampleInvalidScans": "ما المواقع التي سجّلت أكبر عدد من عمليات المسح غير الصالحة هذا الأسبوع؟",
  "ask.exampleMissedScans": "اعرض الحُرّاس الذين فاتتهم 3 عمليات مسح أو أكثر خلال الأيام السبعة الماضية.",
  "ask.exampleNoScansToday": "اعرض قائمة المواقع التي لم تتلقَّ أي عملية مسح اليوم.",
  "ask.exampleOvernightScans": "كم عدد عمليات المسح المسجَّلة ليلاً بين الساعة 22:00 و06:00؟",
  "ask.frequentlyAsked": "الأسئلة الشائعة",
  "ask.hideSql": "إخفاء استعلام SQL",
  "ask.history": "السجل",
  "ask.inputPlaceholder": "اطرح سؤالاً مثل \"ما المواقع التي سجّلت أقل عدد من عمليات المسح أمس؟\"",
  "ask.noHistory": "لا يوجد سجل بعد. اطرح سؤالاً للبدء.",
  "ask.noQueriesMatching": "لا توجد استعلامات تطابق \"{q}\"",
  "ask.rowCountOne": "{n} صف",
  "ask.rowCountOther": "{n} صفوف",
  "ask.searchPlaceholder": "ابحث في الاستعلامات السابقة...",
  "ask.showSql": "عرض استعلام SQL",
  "ask.subtitle": "اسأل عن التزام الدوريات، أو نقاط التفتيش الفائتة، أو أداء الحُرّاس، أو اتجاهات المواقع.",
  "ask.tagline": "مبني على بيانات الدوريات في الوقت الفعلي",
  "ask.thisWeek": "هذا الأسبوع",
  "ask.today": "اليوم",
  "ask.yesterday": "أمس",
  "auth.applyToJoin": "قدِّم طلبًا للانضمام إلى فريقنا",
  "auth.email": "البريد الإلكتروني",
  "auth.enterCredentials": "أدخل بيانات اعتمادك للوصول إلى النظام.",
  "auth.needAccess": "هل تحتاج إلى الوصول إلى نظام الأمن؟",
  "deploy.addFloor": "+ طابق",
  "deploy.addUnplannedCheckpoint": "إضافة نقطة تفتيش غير مخططة",
  "deploy.address": "العنوان",
  "deploy.allSaved": "تم حفظ كل شيء",
  "deploy.area": "المنطقة",
  "deploy.areaDescription": "المنطقة / الوصف",
  "deploy.areaLabel": "المنطقة:",
  "deploy.areaPlaceholder": "مدخل الطوارئ، الجناح الإداري 200…",
  "deploy.areaSuite": "المنطقة / الجناح",
  "deploy.cameraError": "خطأ في الكاميرا:",
  "deploy.cancelScan": "إلغاء المسح",
  "deploy.captureWalkthrough": "جولة الالتقاط",
  "deploy.capturedProgress": "{done} / {total} تم التقاطها",
  "deploy.checkpointsCount": "نقاط التفتيش ({n})",
  "deploy.ckStatusCaptured": "تم الالتقاط",
  "deploy.ckStatusInstalled": "تم التثبيت",
  "deploy.ckStatusPlanned": "مخطط",
  "deploy.ckStatusVerified": "تم التحقق",
  "deploy.clickAnywhereToPlace": "انقر في أي مكان لوضع العلامة",
  "deploy.clickFloorPlan": "انقر على مخطط الطابق…",
  "deploy.complete": "اكتمل!",
  "deploy.completionReport": "تقرير الإكمال",
  "deploy.contactLabel": "جهة الاتصال:",
  "deploy.contactPhone": "هاتف جهة الاتصال",
  "deploy.createAndCapture": "إنشاء والتقاط",
  "deploy.createProject": "إنشاء مشروع",
  "deploy.creating": "جارٍ الإنشاء…",
  "deploy.dismiss": "تجاهل",
  "deploy.editingCheckpoint": "تحرير نقطة التفتيش",
  "deploy.fileFormats": "PNG أو JPG أو PDF",
  "deploy.floor": "الطابق",
  "deploy.floorColon": "الطابق:",
  "deploy.floorLabel": "الطابق:",
  "deploy.floorN": "الطابق {n}",
  "deploy.floorPlanAlt": "مخطط الطابق {n}",
  "deploy.generated": "تم الإنشاء:",
  "deploy.gettingGps": "جارٍ الحصول على GPS…",
  "deploy.gpsFailedRetry": "فشل GPS — أعد المحاولة",
  "deploy.grabGps": "التقاط GPS",
  "deploy.hospitalNameRequired": "اسم المستشفى *",
  "deploy.initials": "الأحرف الأولى: ______",
  "deploy.installVerify": "التثبيت والتحقق",
  "deploy.installedAlt": "مثبّت",
  "deploy.installedVerifiedProgress": "{done} / {total} تم تثبيتها والتحقق منها",
  "deploy.locationDetail": "تفاصيل الموقع",
  "deploy.locationDetailPlaceholder": "يسار الأبواب الرئيسية، فوق معقم اليدين…",
  "deploy.locationDetailShort": "يسار الأبواب الرئيسية…",
  "deploy.locationLabel": "الموقع:",
  "deploy.markInstalledVerified": "وضع علامة كمثبّت ومتحقق منه",
  "deploy.newCheckpoint": "نقطة تفتيش جديدة",
  "deploy.newDeploymentProject": "مشروع نشر جديد",
  "deploy.newProject": "مشروع جديد",
  "deploy.newUnplannedCheckpoint": "نقطة تفتيش جديدة غير مخططة",
  "deploy.noCameraFound": "لم يتم العثور على كاميرا",
  "deploy.noCheckpointsHint": "انقر على \"وضع علامة\" ثم انقر على مخطط الطابق.",
  "deploy.noCheckpointsYet": "لا توجد نقاط تفتيش بعد.",
  "deploy.noProjectSelected": "لم يتم اختيار مشروع",
  "deploy.noProjectSelectedHint": "اختر مشروعًا موجودًا أو أنشئ مشروعًا جديدًا أعلاه.",
  "deploy.noProjectsYet": "لا توجد مشاريع بعد.",
  "deploy.notYetVerified": "لم يتم التحقق بعد",
  "deploy.notes": "ملاحظات",
  "deploy.notesLabel": "ملاحظات:",
  "deploy.notesPlaceholder": "ملاحظات المعالم، تفاصيل التركيب…",
  "deploy.placeCardHere": "ضع البطاقة هنا (من الالتقاط):",
  "deploy.placeMarker": "وضع علامة",
  "deploy.placementNotes": "ملاحظات التركيب",
  "deploy.placementNotesPlaceholder": "ارتفاع 1.5 متر، جدار من الطوب، لاصق دائم…",
  "deploy.placementReferenceAlt": "مرجع التركيب",
  "deploy.print": "طباعة",
  "deploy.printChecklist": "طباعة قائمة التحقق",
  "deploy.qrPlaced": "تم وضع رمز QR",
  "deploy.qrPrefix": "رمز QR:",
  "deploy.recapture": "إعادة الالتقاط",
  "deploy.retakeInstalledPhoto": "إعادة التقاط صورة التثبيت",
  "deploy.retakePhoto": "إعادة التقاط الصورة",
  "deploy.reverify": "إعادة التحقق",
  "deploy.saveCapture": "حفظ الالتقاط",
  "deploy.scanAgain": "امسح مرة أخرى",
  "deploy.scanQrCode": "مسح رمز QR",
  "deploy.scanToVerify": "امسح للتحقق",
  "deploy.scanVerified": "تم التحقق من المسح",
  "deploy.scannedPrefix": "تم المسح:",
  "deploy.selectProject": "اختر مشروعًا…",
  "deploy.selectProjectShort": "اختر المشروع…",
  "deploy.selectProjectToCapture": "اختر مشروعًا لبدء الالتقاط.",
  "deploy.selectProjectToVerify": "اختر مشروعًا لبدء التحقق.",
  "deploy.simulation3d": "محاكاة ثلاثية الأبعاد",
  "deploy.siteContactName": "اسم جهة الاتصال بالموقع",
  "deploy.speechNotSupported": "التعرف على الكلام غير مدعوم في هذا المتصفح.",
  "deploy.statusCapturing": "التقاط",
  "deploy.statusComplete": "مكتمل",
  "deploy.statusFabricating": "تصنيع",
  "deploy.statusInstalling": "تثبيت",
  "deploy.statusPlanning": "تخطيط",
  "deploy.stop": "محطة",
  "deploy.stopNumber": "المحطة رقم {n}",
  "deploy.stopVoice": "إيقاف",
  "deploy.takeInstalledPhoto": "التقاط صورة التثبيت",
  "deploy.takePhoto": "التقاط صورة",
  "deploy.total": "الإجمالي",
  "deploy.unnamed": "بدون اسم",
  "deploy.unnamedLower": "بدون اسم",
  "deploy.unsavedChanges": "تغييرات غير محفوظة...",
  "deploy.uploadFloorPlan": "تحميل مخطط الطابق",
  "deploy.uploadFloorPlanFor": "حمّل مخطط طابق للطابق {n}",
  "deploy.uuidMatched": "تطابق المعرّف الفريد! تم التحقق من رمز QR.",
  "deploy.uuidMismatch": "عدم تطابق المعرّف الفريد. بطاقة QR خاطئة.",
  "deploy.uuidPrefix": "المعرّف الفريد:",
  "deploy.verifiedCheckpoints": "نقاط التفتيش المتحقق منها",
  "deploy.verifiedCount": "تم التحقق",
  "deploy.voice": "صوت",
  "deploy.walkthroughChecklistStops": "قائمة التحقق لجولة النشر — {n} محطات",
  "devices.appVersion": "إصدار التطبيق",
  "devices.deviceManagement": "إدارة الأجهزة",
  "devices.emptyHint": "ستظهر الأجهزة المتصلة هنا بمجرد إرسالها بيانات القياس عن بُعد.",
  "devices.geofences": "الأسوار الجغرافية",
  "devices.hoursAgo": "قبل {n} ساعة",
  "devices.justNow": "الآن",
  "devices.lastLocation": "آخر موقع",
  "devices.locateOnMap": "تحديد موقع الجهاز على الخريطة",
  "devices.minutesAgo": "قبل {n} دقيقة",
  "devices.never": "أبدًا",
  "devices.noDevicesFound": "لم يتم العثور على أجهزة",
  "devices.noGpsData": "لا توجد بيانات GPS",
  "devices.refreshStatus": "تحديث الحالة",
  "devices.violations": "المخالفات",
  "geofence.acknowledge": "إقرار",
  "geofence.acknowledged": "تم الإقرار",
  "geofence.acknowledging": "جارٍ الإقرار...",
  "geofence.actionHeader": "الإجراء",
  "geofence.allGeofences": "جميع السياجات الجغرافية",
  "geofence.create": "إنشاء سياج جغرافي",
  "geofence.createdBy": "أنشأه",
  "geofence.createdDate": "تاريخ الإنشاء",
  "geofence.deleteConfirmBody": "لا يمكن التراجع عن هذا الإجراء. سيتم حذف السياج الجغرافي نهائيًا.",
  "geofence.deleteConfirmTitle": "حذف السياج الجغرافي؟",
  "geofence.drawPolygon": "ارسم مضلعًا على الخريطة",
  "geofence.drawPolygonHint": "انقر على الخريطة لإضافة نقاط. يجب أن يحتوي المضلع على 3 نقاط على الأقل. النقاط الحالية: {n}",
  "geofence.edit": "تحرير السياج الجغرافي",
  "geofence.enterName": "يرجى إدخال اسم للسياج الجغرافي",
  "geofence.failedCreate": "فشل إنشاء السياج الجغرافي",
  "geofence.failedDelete": "فشل حذف السياج الجغرافي",
  "geofence.failedLoad": "فشل تحميل السياجات الجغرافية",
  "geofence.failedSave": "فشل حفظ السياج الجغرافي",
  "geofence.failedUpdate": "فشل تحديث السياج الجغرافي",
  "geofence.filterByGeofence": "تصفية حسب السياج الجغرافي",
  "geofence.geofenceHeader": "السياج الجغرافي",
  "geofence.gpsCoordinates": "إحداثيات GPS",
  "geofence.hoursAgo": "قبل {n} ساعة",
  "geofence.justNow": "الآن",
  "geofence.management": "إدارة السياجات الجغرافية",
  "geofence.managementSubtitle": "حدّد المناطق الآمنة وراقب انتهاكات الحدود",
  "geofence.minPoints": "يجب أن يحتوي المضلع على 3 نقاط على الأقل",
  "geofence.minutesAgo": "قبل {n} دقيقة",
  "geofence.nameLabel": "اسم السياج الجغرافي",
  "geofence.namePlaceholder": "مثال: المدخل الرئيسي، موقف السيارات A",
  "geofence.noViolations": "لم يتم اكتشاف أي انتهاكات",
  "geofence.noViolationsHint": "جميع الأجهزة داخل السياجات الجغرافية المخصصة لها.",
  "geofence.noneConfigured": "لا توجد سياجات جغرافية مهيّأة لموقعك.",
  "geofence.noneYet": "لا توجد سياجات جغرافية بعد",
  "geofence.noneYetCanCreate": "أنشئ أول سياج جغرافي لك لبدء مراقبة الحدود.",
  "geofence.pointN": "النقطة {n}:",
  "geofence.polygonPoints": "نقاط المضلع ({n})",
  "geofence.preview": "معاينة",
  "geofence.save": "حفظ السياج الجغرافي",
  "geofence.selectHospitalAlert": "يرجى اختيار مستشفى",
  "geofence.selectHospitalOption": "اختر مستشفى...",
  "geofence.unacknowledged": "غير مُقرّ بها",
  "geofence.unacknowledgedCount": "{n} غير مُقرّ بها",
  "geofence.violationsSubtitle": "راقب وأقرّ بانتهاكات الحدود",
  "geofence.violationsTitle": "انتهاكات السياج الجغرافي",
  "help.callNow": "اتصل الآن",
  "help.comingSoon": "قريبًا",
  "help.docsComingSoon": "الوثائق قريبًا.",
  "help.emailSupport": "الدعم عبر البريد الإلكتروني",
  "help.escalateIssue": "تصعيد المشكلة",
  "help.guardHeadline": "مساعدة ودعم الحرّاس",
  "help.guidesFaq": "الأدلة والأسئلة الشائعة",
  "help.incidentEscalation": "تصعيد الحوادث",
  "help.incidentEscalationDesc": "أبلغ عن الأعطال أو إخفاقات الأكشاك أو مشكلات المسح العاجلة.",
  "help.intro": "تواصل مع فريق دورية الأمن في Emory أو راجع خطوات استكشاف الأخطاء وإصلاحها السريعة.",
  "help.phoneHotline": "الخط الساخن الهاتفي",
  "help.phoneHotlineValue": "(404) 555-0199 • على مدار الساعة طوال أيام الأسبوع",
  "help.quickTips": "نصائح سريعة",
  "help.sendEmail": "إرسال بريد إلكتروني",
  "help.supervisorHeadline": "مساعدة ودعم المشرفين",
  "help.support": "الدعم",
  "help.tipAskAi": "استخدم صفحة اسأل الذكاء الاصطناعي لسحب البيانات التاريخية قبل التواصل مع الدعم.",
  "help.tipRefresh": "حدّث الصفحة إذا بدت عمليات المسح متأخرة أو قديمة.",
  "help.tipReinstall": "يمكن للحرّاس إعادة تثبيت تطبيق الويب التقدّمي (PWA) من صفحة الإعدادات عند اختفاء الأيقونة.",
  "home.activeCheckpoints": "نقاط التفتيش النشطة",
  "home.activeCheckpointsTooltip": "العدد الإجمالي لمواقع رموز الاستجابة السريعة المادية المسجلة حاليًا في هذا المستشفى.",
  "home.addNewMarker": "إضافة علامة جديدة",
  "home.allHospitalsAggregated": "جميع المستشفيات (مجمعة)",
  "hospitals.allAggregated": "جميع المستشفيات (مجمعة)",
  "home.building": "المبنى",
  "home.buildingFloor": "{building} - الطابق {floor}",
  "home.cancelPlacement": "إلغاء التحديد",
  "home.chartScans": "عمليات المسح:",
  "home.checkpointName": "اسم نقطة التفتيش",
  "home.checkpointNamePlaceholder": "مثال: المالية (الغرب)",
  "home.checkpointsScanned": "نقاط التفتيش الممسوحة",
  "home.chooseCheckpoint": "— اختر نقطة تفتيش —",
  "home.cleared": "تمت التصفية",
  "home.clickToPlace": "انقر في أي مكان على الخريطة لوضع علامة جديدة.",
  "home.comparingScanVolume": "مقارنة حجم المسح النشط عبر جميع المواقع المسجلة",
  "home.complianceRate": "معدل الامتثال",
  "home.complianceRateTooltip": "النسبة المئوية لنقاط التفتيش المسجلة التي تم مسحها مرة واحدة على الأقل خلال الوردية الحالية.",
  "home.complianceRateValue": "معدل الامتثال: {n}%",
  "home.confirmDeleteCheckpoint": "هل أنت متأكد من أنك تريد حذف نقطة التفتيش هذه؟ لا يمكن التراجع عن هذا الإجراء.",
  "home.createCustomCheckpoint": "+ إنشاء نقطة تفتيش مخصصة...",
  "home.deleteMarker": "حذف العلامة",
  "home.dragToReposition": "اسحب العلامات لإعادة وضعها. يتم حفظ التغييرات تلقائيًا.",
  "home.editModeOn": "وضع التحرير مُفعّل",
  "home.editPositions": "تحرير المواضع",
  "home.failedDeleteLocation": "فشل حذف الموقع",
  "home.failedSaveLocation": "فشل حفظ الموقع",
  "home.floor": "الطابق",
  "home.floorAbbr": "ط {n}",
  "home.floorN": "الطابق {n}",
  "home.headerSubtitle": "التحقق من الدوريات في الوقت الفعلي وحالة تحميل المحور",
  "home.hospitalPerformanceComparison": "مقارنة أداء المستشفيات",
  "home.hospitalSecurity": "أمن المستشفى",
  "home.hub": "المحور: {hub}",
  "home.internalServerError": "خطأ داخلي في الخادم",
  "home.lastHour": "الساعة الأخيرة",
  "home.lastScan": "آخر مسح",
  "home.lastUpdated": "آخر تحديث:",
  "home.legendError": "خطأ",
  "home.legendInvalid": "غير صالح",
  "home.legendOk": "سليم",
  "home.liveSystem": "النظام المباشر",
  "home.loadingCheckpoints": "جارٍ تحميل نقاط التفتيش...",
  "home.loadingComplianceData": "جارٍ تحميل بيانات الامتثال...",
  "home.loadingUploads": "جارٍ تحميل التحميلات...",
  "home.mapLast30Days": "آخر 30 يومًا",
  "home.mapLast7Days": "آخر 7 أيام",
  "home.mapLastQuarter": "الربع الأخير",
  "home.mapSubtitle": "تتبع الدوريات في الوقت الفعلي وحالة نقاط التفتيش",
  "home.mapTitle": "خريطة النشاط المباشر للمستشفى",
  "home.mapTodaysScans": "عمليات مسح اليوم",
  "home.moreCheckpoints": "+ {n} نقاط تفتيش إضافية",
  "home.noCheckpointsConfigured": "لا توجد نقاط تفتيش مهيأة لهذا المستشفى.",
  "home.noCheckpointsLoaded": "لم يتم تحميل أي نقاط تفتيش. تحقق من اتصال قاعدة البيانات أو أضف واحدة يدويًا أدناه.",
  "home.noUploadsToday": "لم يتم تسجيل أي تحميلات اليوم.",
  "home.numberOfScans": "عدد عمليات المسح",
  "home.pendingClear": "في انتظار التصفية",
  "home.placeCheckpoint": "وضع نقطة تفتيش",
  "home.positionLabel": "الموضع:",
  "home.qrPayload": "حمولة رمز QR",
  "home.qrPayloadPlaceholder": "مثال: FINANCE_WEST",
  "home.recentPatrolActivity7Days": "نشاط الدورية الأخير (7&nbsp;أيام)",
  "home.recentScans7Days": "عمليات المسح الأخيرة (7&nbsp;أيام)",
  "home.recentScansTooltip": "العدد الإجمالي لعمليات مسح الدوريات التي تم تحميلها والتحقق منها بنجاح خلال الأيام السبعة الماضية.",
  "home.registeredCheckpoints": "نقاط التفتيش المسجلة",
  "home.roleDashboard": "لوحة معلومات {role}:",
  "home.saveCheckpoint": "حفظ نقطة التفتيش",
  "home.scanner": "الماسح: {serial}",
  "home.scansCount": "{n} عمليات مسح",
  "home.selectCheckpoint": "اختر نقطة تفتيش",
  "home.tooltipPosition": "الموضع",
  "home.unknownHospital": "مستشفى غير معروف",
  "home.uploadsByShift": "التحميلات حسب الوردية",
  "home.viewingHospital": "المستشفى المعروض:",
  "landing.addressInfo": "معلومات العنوان",
  "landing.agreeTerms": "أوافق على شروط الخدمة",
  "landing.agreeTermsDetail": "أدرك أن الوصول إلى نظام دوريات الأمن يتوقف على موافقة المشرف وأن جميع المعلومات المقدَّمة دقيقة وكاملة.",
  "landing.availableShifts": "المناوبات المتاحة (اختر كل ما ينطبق)",
  "landing.bulletIntegrity": "تحليلات النزاهة لعمليات المسح الفائتة والأحداث المُعلَّمة.",
  "landing.bulletMonitoring": "مراقبة فورية لكل بهو ومدخل وممر.",
  "landing.bulletWorkspace": "مساحة عمل موحَّدة للمشرفين مع بحث فوري ورؤى مدعومة بالذكاء الاصطناعي.",
  "landing.city": "المدينة",
  "landing.completeAndAgree": "يُرجى إكمال جميع الحقول المطلوبة والموافقة على الشروط.",
  "landing.confirmPassword": "تأكيد كلمة المرور",
  "landing.confirmYourPassword": "أكِّد كلمة المرور الخاصة بك",
  "landing.createPassword": "أنشئ كلمة مرور آمنة",
  "landing.dateOfBirth": "تاريخ الميلاد",
  "landing.emailAddress": "عنوان البريد الإلكتروني",
  "landing.emailRegistered": "عنوان البريد الإلكتروني هذا مُسجَّل بالفعل.",
  "landing.emailRegisteredUseDifferent": "عنوان البريد الإلكتروني هذا مُسجَّل بالفعل. يُرجى استخدام عنوان بريد إلكتروني مختلف.",
  "landing.emergencyContact": "جهة اتصال الطوارئ",
  "landing.emergencyContactName": "اسم جهة اتصال الطوارئ",
  "landing.emergencyContactPhone": "هاتف جهة اتصال الطوارئ",
  "landing.fillRequiredContinue": "يُرجى ملء جميع الحقول المطلوبة قبل المتابعة.",
  "landing.firstName": "الاسم الأول",
  "landing.lastName": "اسم العائلة",
  "landing.next": "التالي",
  "landing.passwordsNoMatch": "كلمتا المرور غير متطابقتين",
  "landing.percentComplete": "اكتمل {p}%",
  "landing.personalInfo": "المعلومات الشخصية",
  "landing.phoneNumber": "رقم الهاتف",
  "landing.phoneRegistered": "رقم الهاتف هذا مُسجَّل بالفعل.",
  "landing.phoneRegisteredUseDifferent": "رقم الهاتف هذا مُسجَّل بالفعل. يُرجى استخدام رقم هاتف مختلف.",
  "landing.relChild": "ابن/ابنة",
  "landing.relFriend": "صديق/صديقة",
  "landing.relOther": "أخرى",
  "landing.relParent": "أحد الوالدين",
  "landing.relSibling": "أخ/أخت",
  "landing.relSpouse": "الزوج/الزوجة",
  "landing.relationship": "صلة القرابة",
  "landing.requestAccessSubtitle": "أكمل هذا النموذج لطلب الوصول إلى نظام دوريات الأمن.",
  "landing.requestAccessTitle": "طلب الوصول إلى النظام",
  "landing.requestSubmitted": "تم إرسال طلب الحساب",
  "landing.requestSubmittedApproval": "ستتمكن من تسجيل الدخول باستخدام بيانات اعتمادك بمجرد الموافقة. تستغرق هذه العملية عادةً يومًا إلى يومي عمل.",
  "landing.requestSubmittedThanks": "شكرًا لطلبك الوصول إلى نظام دوريات الأمن. تم إرسال طلبك وهو قيد موافقة المشرفين.",
  "landing.requestedRole": "الدور المطلوب",
  "landing.returnHome": "العودة إلى الصفحة الرئيسية",
  "landing.returnToLogin": "العودة إلى تسجيل الدخول",
  "landing.roleAvailability": "الدور والتوفر",
  "landing.securityDirector": "مدير الأمن",
  "landing.securitySupervisor": "مشرف الأمن",
  "landing.selectEllipsis": "اختر...",
  "landing.shiftDay": "مناوبة النهار (6 صباحًا - 2 ظهرًا)",
  "landing.shiftEvening": "المناوبة المسائية (2 ظهرًا - 10 مساءً)",
  "landing.shiftHolidays": "العطلات",
  "landing.shiftNight": "المناوبة الليلية (10 مساءً - 6 صباحًا)",
  "landing.shiftOnCall": "تحت الطلب",
  "landing.shiftWeekends": "عطلات نهاية الأسبوع",
  "landing.signInSubheading": "استخدم بيانات اعتماد المشرف أو الحارس للمتابعة.",
  "landing.signInToGuard": "تسجيل الدخول إلى Guard",
  "landing.somethingWrong": "حدث خطأ ما.",
  "landing.state": "الولاية",
  "landing.stepOf": "الخطوة {n} من 4",
  "landing.streetAddress": "عنوان الشارع",
  "landing.submitApplication": "إرسال الطلب",
  "landing.submitFailed": "تعذَّر إرسال الطلب. يُرجى المحاولة مرة أخرى.",
  "landing.submitting": "جارٍ الإرسال...",
  "landing.termsOfService": "شروط الخدمة",
  "landing.zipCode": "الرمز البريدي",
  "live.action": "إجراء",
  "live.activityFeed": "موجز النشاط",
  "live.asOf": "اعتبارًا من {time}",
  "live.colCoordinate": "الإحداثيات",
  "live.colDateTime": "التاريخ والوقت",
  "live.colDistance": "المسافة",
  "live.deviceLocation": "(موقع الجهاز)",
  "live.filterAll": "كل النشاط",
  "live.filterInvalid": "عمليات المسح غير الصالحة",
  "live.filterValid": "عمليات المسح الصالحة",
  "live.floor": "الطابق {n}",
  "live.freshFix": "(تحديد موقع حديث)",
  "live.loadingActivity": "جارٍ تحميل نشاط الدورية…",
  "live.metersAway": "على بُعد {n} متر",
  "live.noGpsData": "لا توجد بيانات GPS",
  "live.noScansFilter": "لا توجد عمليات مسح تطابق هذا المرشّح.",
  "live.syncData": "مزامنة البيانات",
  "live.timeframe": "الإطار الزمني",
  "live.unknownHospital": "مستشفى غير معروف",
  "live.unknownLocation": "موقع غير معروف",
  "live.view3d": "عرض ثلاثي الأبعاد",
  "live.view3dWorld": "عرض العالم ثلاثي الأبعاد لنقطة التفتيش هذه",
  "map.allHospitals": "جميع المستشفيات",
  "map.autoRefresh": "تحديث تلقائي",
  "map.autoRefreshTitle": "تحديث تلقائي كل 30 ثانية",
  "map.dark": "داكن",
  "map.expandLegend": "توسيع وسيلة الإيضاح",
  "map.gpsDisclaimer": "تعكس مواضع المسح دقة نظام تحديد المواقع للجهاز. قد تختلف الإشارات داخل المباني بمقدار 10–50 مترًا عن الموقع الفعلي.",
  "map.heatmap": "خريطة حرارية",
  "map.heatmapTitle": "تبديل الخريطة الحرارية للكثافة",
  "map.legend": "وسيلة الإيضاح",
  "map.light": "فاتح",
  "map.limitedWarning": "تعرض الخريطة ما يصل إلى {max} عملية مسح كحد أقصى. يُرجى تضييق النطاق الزمني أو عامل تصفية المستشفى لرؤية بيانات محددة.",
  "map.loadFailed": "فشل تحميل عمليات المسح",
  "map.loadingScans": "جارٍ تحميل عمليات المسح…",
  "map.mapStyle": "نمط الخريطة: {name}",
  "map.markers": "العلامات",
  "map.minimizeLegend": "تصغير وسيلة الإيضاح",
  "map.noGpsScans": "لم يتم العثور على عمليات مسح موسومة بنظام تحديد المواقع لهذا النطاق الزمني.",
  "map.pageSubtitle": "عرض جغرافي مباشر للأماكن التي حدثت فيها أحداث المسح.",
  "map.pageTitle": "خريطة المسح GuardAI",
  "map.popupHospital": "المستشفى:",
  "map.popupScanner": "الماسح:",
  "map.popupTime": "الوقت:",
  "map.rangeCustom": "نطاق مخصص",
  "map.rangeLast24h": "آخر 24 ساعة",
  "map.rangeLast30d": "آخر 30 يومًا",
  "map.rangeLast7d": "آخر 7 أيام",
  "map.rangeLastHour": "آخر ساعة",
  "map.showingMaxScans": "عرض {shown} (الحد الأقصى) من أصل {total} عملية مسح",
  "map.snapToBuilding": "محاذاة إلى المبنى",
  "map.snapToBuildingTitle": "محاذاة نقاط نظام تحديد المواقع نحو مراكز المباني لمواجهة انحراف GPS داخل المباني",
  "map.switchToDark": "التبديل إلى الخريطة الداكنة",
  "map.switchToLight": "التبديل إلى الخريطة الفاتحة",
  "map.to": "إلى",
  "map.totalScans": "{total} عملية مسح",
  "map.unknownHospital": "غير معروف",
  "map.updatedAt": "تم التحديث {time}",
  "reportBuilder.addWidget": "إضافة عنصر واجهة",
  "reportBuilder.aiAssistant": "مساعد التقارير بالذكاء الاصطناعي",
  "reportBuilder.aiPlaceholder": "صِف التقرير الذي تريده — مثل «عدد عمليات المسح حسب المستشفى للشهر الماضي مع مخطط شريطي». أو ارسم تخطيطًا على الورق وارفع صورة.",
  "reportBuilder.aiSummaryHint": "انقر على «إنشاء» لكتابة ملاحظات من بيانات تقريرك.",
  "reportBuilder.allHospitals": "جميع المستشفيات",
  "reportBuilder.allTime": "كل الأوقات",
  "reportBuilder.assistantUnavailable": "المساعد غير متاح حاليًا.",
  "reportBuilder.author": "المؤلف",
  "reportBuilder.beta": "تجريبي",
  "reportBuilder.buildItForMe": "أنشئه لي",
  "reportBuilder.buildTogether": "لنُنشئه معًا",
  "reportBuilder.canvasEmpty": "لوحتك فارغة",
  "reportBuilder.canvasEmptyHint": "أضف عنصر واجهة من شريط الأدوات أعلاه، أو انقر على حقل بيانات على اليسار، أو ابدأ من قالب.",
  "reportBuilder.captionPlaceholder": "تعليق (اختياري)",
  "reportBuilder.color": "اللون",
  "reportBuilder.compareAgainst": "مقارنة مع",
  "reportBuilder.configure": "تهيئة",
  "reportBuilder.copySuffix": "(نسخة)",
  "reportBuilder.couldntSave": "تعذّر الحفظ:",
  "reportBuilder.dataFields": "حقول البيانات",
  "reportBuilder.dataFieldsHint": "انقر على أي حقل لإضافة عنصر واجهة جاهز إلى تقريرك.",
  "reportBuilder.dataSource": "مصدر البيانات",
  "reportBuilder.dateFrom": "من {date}",
  "reportBuilder.dateFromLabel": "التاريخ من",
  "reportBuilder.dateThrough": "حتى {date}",
  "reportBuilder.dateToLabel": "التاريخ إلى",
  "reportBuilder.dayOfWeekOpt": "يوم الأسبوع",
  "reportBuilder.describeOrSketch": "صِف التقرير الذي تريده، أو أرفق رسمًا تخطيطيًا.",
  "reportBuilder.dismiss": "تجاهل",
  "reportBuilder.done": "تم",
  "reportBuilder.donutStyle": "نمط الحلقة",
  "reportBuilder.draftedOffline": " · تمت صياغته دون اتصال",
  "reportBuilder.duplicate": "تكرار",
  "reportBuilder.example1": "عدد عمليات المسح حسب المستشفى للشهر الماضي، مع مخطط شريطي",
  "reportBuilder.example2": "نشاط الدوريات اليومي مع ساعات الذروة والأجهزة النشطة",
  "reportBuilder.example3": "تغطية نقاط التفتيش: المفحوصة مقابل غير المفحوصة حسب المستشفى",
  "reportBuilder.exportCsv": "CSV (بيانات)",
  "reportBuilder.exportFailed": "فشل التصدير:",
  "reportBuilder.exportHtml": "HTML (قابل للمشاركة)",
  "reportBuilder.exportPdf": "PDF (جاهز للطباعة)",
  "reportBuilder.exportPng": "صورة PNG",
  "reportBuilder.exportPrint": "طباعة",
  "reportBuilder.exportSlides": "جاهز للشرائح (HTML)",
  "reportBuilder.exportTryPdf": "جرّب PDF (طباعة) بدلاً من ذلك.",
  "reportBuilder.exportXls": "Excel (.xls)",
  "reportBuilder.fieldTitle": "العنوان",
  "reportBuilder.filterFloor": "تصفية: الطابق",
  "reportBuilder.filterHospital": "تصفية: المستشفى",
  "reportBuilder.floorPlaceholder": "مثل L1، 5، Plaza",
  "reportBuilder.generate": "إنشاء",
  "reportBuilder.generateBtn": "إنشاء",
  "reportBuilder.generatedBy": "تم الإنشاء بواسطة GuardAI · © {year} G-Data Labs. جميع الحقوق محفوظة.",
  "reportBuilder.generating": "جارٍ الإنشاء…",
  "reportBuilder.group": "المجموعة",
  "reportBuilder.groupBy": "تجميع حسب",
  "reportBuilder.hideSettings": "إخفاء الإعدادات",
  "reportBuilder.horizontal": "أفقي",
  "reportBuilder.imageTooLarge": "هذه الصورة كبيرة بعض الشيء — يُرجى استخدام صورة أقل من 6 ميغابايت.",
  "reportBuilder.imageUrlPlaceholder": "رابط الصورة (اختياري)",
  "reportBuilder.includeLogo": "تضمين شعار GuardAI",
  "reportBuilder.loadFailed": "تعذّر تحميل البيانات.",
  "reportBuilder.lookAt": "انظر إلى {target}",
  "reportBuilder.maxRows": "الحد الأقصى للصفوف",
  "reportBuilder.metric": "المقياس",
  "reportBuilder.moreSettings": "مزيد من الإعدادات",
  "reportBuilder.moveDown": "نقل لأسفل",
  "reportBuilder.moveUp": "نقل لأعلى",
  "reportBuilder.next": "التالي",
  "reportBuilder.noDataSelection": "لا توجد بيانات لهذا التحديد",
  "reportBuilder.noImageUploaded": "لم يتم رفع أي صورة",
  "reportBuilder.noLayout": "لم أتمكن من تحويل ذلك إلى تخطيط — جرّب وصف المقاييس وكيفية تجميعها.",
  "reportBuilder.noSummary": "لم يتم إنشاء أي ملخص.",
  "reportBuilder.noWidgetsYet": "لا يحتوي هذا التقرير على عناصر واجهة بعد.",
  "reportBuilder.optionalSubtitle": "عنوان فرعي اختياري",
  "reportBuilder.orientation": "الاتجاه",
  "reportBuilder.period": "الفترة: {range}",
  "reportBuilder.preparedBy": "أعدّه {name}",
  "reportBuilder.preview": "معاينة",
  "reportBuilder.previewHint": "هكذا سيتم تصدير تقريرك وطباعته. استخدم زر التصدير أعلاه للتنزيل.",
  "reportBuilder.regenerate": "إعادة الإنشاء",
  "reportBuilder.remove": "إزالة",
  "reportBuilder.removeImage": "إزالة الصورة",
  "reportBuilder.reportImage": "صورة التقرير",
  "reportBuilder.reportTitle": "عنوان التقرير",
  "reportBuilder.reportsAnalytics": "التقارير والتحليلات",
  "reportBuilder.saveAsTemplate": "حفظ التقرير الحالي كقالب مشترك",
  "reportBuilder.savedAt": "تم الحفظ في {time}",
  "reportBuilder.savedReports": "التقارير المحفوظة",
  "reportBuilder.secondSeriesLabel": "تسمية السلسلة الثانية",
  "reportBuilder.secondSeriesMetric": "مقياس السلسلة الثانية",
  "reportBuilder.secondSeriesSource": "مصدر السلسلة الثانية",
  "reportBuilder.selectWidget": "حدّد عنصر واجهة لتهيئته.",
  "reportBuilder.seriesB": "السلسلة ب",
  "reportBuilder.sketch": "رسم تخطيطي",
  "reportBuilder.sketchAlt": "رسم تخطيطي",
  "reportBuilder.sort": "ترتيب",
  "reportBuilder.sortLabelAsc": "الاسم، أ → ي",
  "reportBuilder.sortLabelDesc": "الاسم، ي → أ",
  "reportBuilder.sortValueAsc": "القيمة، من الأدنى إلى الأعلى",
  "reportBuilder.sortValueDesc": "القيمة، من الأعلى إلى الأدنى",
  "reportBuilder.startFromTemplate": "ابدأ من قالب",
  "reportBuilder.startNewReport": "بدء تقرير جديد",
  "reportBuilder.stepOf": "الخطوة {n} من {total}",
  "reportBuilder.subtitle": "العنوان الفرعي",
  "reportBuilder.summaryFailed": "فشل إنشاء الملخص.",
  "reportBuilder.targetAiBar": "شريط مساعد الذكاء الاصطناعي",
  "reportBuilder.targetCanvas": "لوحة التقرير",
  "reportBuilder.targetConfigPanel": "لوحة التهيئة",
  "reportBuilder.targetDataFields": "لوحة حقول البيانات",
  "reportBuilder.targetExport": "زر التصدير",
  "reportBuilder.targetPreview": "زر تبديل المعاينة",
  "reportBuilder.targetSave": "زر الحفظ",
  "reportBuilder.targetTemplates": "زر القوالب",
  "reportBuilder.targetToolbar": "شريط أدوات عناصر الواجهة",
  "reportBuilder.templates": "القوالب",
  "reportBuilder.textPlaceholder": "اكتب نصك. استخدم ## لعنوان و **غامق** للتأكيد.",
  "reportBuilder.thinking": "جارٍ التفكير…",
  "reportBuilder.title": "منشئ التقارير",
  "reportBuilder.total": "الإجمالي",
  "reportBuilder.try": "جرّب:",
  "reportBuilder.untitledReport": "تقرير بدون عنوان",
  "reportBuilder.uploadSketchTitle": "ارفع صورة لتخطيط تقرير مرسوم يدويًا",
  "reportBuilder.vertical": "عمودي",
  "reportBuilder.walkMeThrough": "أرشدني خطوة بخطوة",
  "reportBuilder.widgetCountMany": "{n} عناصر واجهة",
  "reportBuilder.widgetCountOne": "{n} عنصر واجهة",
  "reportBuilder.width": "العرض",
  "reportBuilder.widthFull": "كامل",
  "reportBuilder.working": "جارٍ العمل…",
  "reports.activeGuards": "الحراس النشطون",
  "reports.asOfTime": "(حتى {time})",
  "reports.averageCompliance": "متوسط الامتثال",
  "reports.averageResponseTime": "متوسط وقت الاستجابة",
  "reports.checkpointLocationAnalysis": "تحليل مواقع نقاط التفتيش",
  "reports.checkpointsCompleted": "نقاط التفتيش المكتملة",
  "reports.checkpointsLoggedGps": "({n} نقاط تفتيش مسجلة من بيانات GPS)",
  "reports.colCompliance": "الامتثال",
  "reports.colPerformance": "الأداء",
  "reports.compliance90to94": "امتثال 90-94%",
  "reports.compliance95": "امتثال ≥95%",
  "reports.complianceBelow90": "امتثال <90%",
  "reports.complianceLabel": "الامتثال",
  "reports.complianceReport": "تقرير الامتثال",
  "reports.coverageComplianceHelp": "نسبة نقاط التفتيش التي تمت زيارتها مرة واحدة على الأقل خلال هذه الفترة",
  "reports.coverageComplianceTrends": "اتجاهات امتثال التغطية",
  "reports.criticalIssuesResolved": "المشكلات الحرجة التي تم حلها",
  "reports.currentTime": "الحالي: {time}",
  "reports.dayFri": "الجمعة",
  "reports.dayFriday": "الجمعة",
  "reports.dayMon": "الإثنين",
  "reports.dayMonday": "الإثنين",
  "reports.daySat": "السبت",
  "reports.daySaturday": "السبت",
  "reports.daySun": "الأحد",
  "reports.daySunday": "الأحد",
  "reports.dayThu": "الخميس",
  "reports.dayThursday": "الخميس",
  "reports.dayTue": "الثلاثاء",
  "reports.dayTuesday": "الثلاثاء",
  "reports.dayWed": "الأربعاء",
  "reports.dayWednesday": "الأربعاء",
  "reports.deltaLastMonth": "+1.8% عن الشهر الماضي",
  "reports.deltaLastQuarter": "+3.2% عن الربع الماضي",
  "reports.deltaLastWeek": "+2.1% عن الأسبوع الماضي",
  "reports.deltaYesterday": "+1.5% عن الأمس",
  "reports.downloadReport": "تنزيل التقرير",
  "reports.exceptions": "استثناءات",
  "reports.exportFormat": "صيغة التصدير",
  "reports.exportReport": "تصدير التقرير",
  "reports.guardPerformanceAnalysis": "تحليل أداء الحراس",
  "reports.heatmapCellTitle": "{location} - {label}: {pct}% نشاط",
  "reports.lessActivity": "نشاط أقل",
  "reports.loadingPatrolActivity": "جارٍ تحميل نشاط الدورية…",
  "reports.locationAbbreviations": "اختصارات المواقع:",
  "reports.locationActivityHeatmap": "خريطة حرارية لنشاط المواقع",
  "reports.missedCheckpoints": "نقاط التفتيش الفائتة",
  "reports.missedCount": "{n} فائتة",
  "reports.monFeb": "فبراير",
  "reports.monJan": "يناير",
  "reports.monMar": "مارس",
  "reports.monthN": "الشهر {n}",
  "reports.moreActivity": "نشاط أكثر",
  "reports.noChange": "لا تغيير",
  "reports.noCoverageData": "لا توجد بيانات تغطية بعد",
  "reports.noDataForPeriod": "لا توجد بيانات للفترة",
  "reports.noScanLocations": "لا توجد مواقع مسح لرموز QR متاحة",
  "reports.notAvailable": "غير متاح",
  "reports.overallComplianceRate": "معدل الامتثال الإجمالي",
  "reports.patrolLocations": "مواقع الدوريات",
  "reports.periodMonth": "هذا الشهر",
  "reports.periodQuarter": "هذا الربع",
  "reports.periodToday": "اليوم",
  "reports.periodWeek": "هذا الأسبوع",
  "reports.popupCompliance": "الامتثال:",
  "reports.popupLast": "الأخير:",
  "reports.popupScans": "عمليات المسح:",
  "reports.qrScanLocations": "مواقع مسح رموز QR",
  "reports.quickExportOptions": "خيارات التصدير السريع",
  "reports.realScanData": "بيانات المسح الفعلية (آخر 24 ساعة)",
  "reports.scanToSeeLocations": "امسح رموز QR لرؤية المواقع على الخريطة",
  "reports.scansCount": "{n} عملية مسح",
  "reports.scansThisMonth": "{n} عملية مسح هذا الشهر",
  "reports.scansThisQuarter": "{n} عملية مسح هذا الربع",
  "reports.scansThisWeek": "{n} عملية مسح هذا الأسبوع",
  "reports.scansToday": "{n} عملية مسح اليوم",
  "reports.tabCompliance": "الامتثال",
  "reports.tabGuardPerformance": "أداء الحراس",
  "reports.tabLocationAnalysis": "تحليل المواقع",
  "reports.tabOverview": "نظرة عامة",
  "reports.totalScans": "إجمالي عمليات المسح",
  "reports.trackingLocationsGuards": "تتبع {locations} مواقع و {guards} حراس.",
  "reports.trendDaily": "اتجاهات الأداء اليومية",
  "reports.trendHourly": "اتجاهات الأداء بالساعة",
  "reports.trendMonthly": "اتجاهات الأداء الشهرية",
  "reports.trendTooltip": "{pct}% ({n} مواقع)",
  "reports.trendWeekly": "اتجاهات الأداء الأسبوعية",
  "reports.validated": "تم التحقق",
  "reports.viewDetails": "عرض التفاصيل",
  "reports.weekN": "الأسبوع {n}",
  "reports.weeklySummary": "ملخص أسبوعي",
  "reports.wk1": "أسبوع1",
  "reports.wk2": "أسبوع2",
  "reports.wk3": "أسبوع3",
  "reports.wk4": "أسبوع4",
  "schedules.activeRoutes": "المسارات النشطة",
  "schedules.activeSchedules": "الجداول النشطة",
  "schedules.addNewSchedule": "إضافة جدول جديد",
  "schedules.addSchedule": "إضافة جدول",
  "schedules.assignedGuard": "الحارس المُعيَّن",
  "schedules.assignedGuards": "الحراس المُعيَّنون",
  "schedules.calendar": "التقويم",
  "schedules.confirmDelete": "هل أنت متأكد من رغبتك في حذف هذا الجدول؟",
  "schedules.coverageGaps": "فجوات التغطية",
  "schedules.createSchedule": "إنشاء جدول",
  "schedules.dayFri": "الجمعة",
  "schedules.dayMon": "الاثنين",
  "schedules.daySat": "السبت",
  "schedules.daySun": "الأحد",
  "schedules.dayThu": "الخميس",
  "schedules.dayTue": "الثلاثاء",
  "schedules.dayWed": "الأربعاء",
  "schedules.daysOfWeek": "أيام الأسبوع",
  "schedules.deleteSchedule": "حذف الجدول",
  "schedules.editSchedule": "تعديل الجدول",
  "schedules.endTime": "وقت الانتهاء",
  "schedules.fillRequired": "يرجى ملء جميع الحقول المطلوبة",
  "schedules.frequency": "التكرار",
  "schedules.frequencyCustom": "مخصص",
  "schedules.frequencyDaily": "يومي",
  "schedules.frequencyWeekly": "أسبوعي",
  "schedules.listView": "عرض القائمة",
  "schedules.morningPatrol": "دورية الصباح",
  "schedules.nightShift": "النوبة الليلية",
  "schedules.route": "المسار",
  "schedules.scheduleName": "اسم الجدول",
  "schedules.scheduleNamePlaceholder": "مثال: دورية الصباح - المبنى أ",
  "schedules.selectGuard": "اختر حارسًا",
  "schedules.selectRoute": "اختر مسارًا",
  "schedules.selectedCount": "المحدد: {n} نقطة تفتيش",
  "schedules.startTime": "وقت البدء",
  "schedules.updateSchedule": "تحديث الجدول",
  "settings.browserDesc": "يُسجَّل وكيل المستخدم (UA) لمراقبة سلامة الجهاز.",
  "settings.browserLabel": "المتصفح",
  "settings.cameraDesc": "مطلوب لمسح رموز QR. اضبطه في إعدادات النظام إذا تم رفضه.",
  "settings.cameraPermission": "إذن الكاميرا",
  "settings.deviceIdDesc": "بصمة تُخزَّن مع كل عملية مسح لأغراض الامتثال للتدقيق.",
  "settings.deviceIdLabel": "معرّف الجهاز",
  "settings.email": "البريد الإلكتروني",
  "settings.escalationAlerts": "تنبيهات التصعيد",
  "settings.fullName": "الاسم الكامل",
  "settings.installPwa": "التثبيت كتطبيق ويب تقدّمي (PWA)",
  "settings.locationDesc": "مطلوب للتحقق عبر نظام تحديد المواقع (GPS) عند كل نقطة تفتيش.",
  "settings.locationPermission": "إذن الموقع",
  "settings.mobilePhone": "الهاتف المحمول",
  "settings.notRegistered": "غير مُسجَّل بعد",
  "settings.notificationDesc": "تحكّم في التنبيهات التي يمكن لفريق الإشراف إرسالها إليك.",
  "settings.notificationPreferences": "تفضيلات الإشعارات",
  "settings.permGranted": "ممنوح",
  "settings.permUnknown": "غير معروف",
  "settings.profileDetails": "تفاصيل الملف الشخصي",
  "settings.profileSavedMsg": "تم حفظ تفضيلات الملف الشخصي. تسري التغييرات على الفور.",
  "settings.pwaAndroid": "Android (Chrome):",
  "settings.pwaAndroidSteps": "القائمة ← تثبيت التطبيق.",
  "settings.pwaDesktop": "سطح المكتب:",
  "settings.pwaDesktopSteps": "استخدم مطالبة التثبيت في المتصفح ضمن شريط العناوين.",
  "settings.pwaIos": "iOS (Safari):",
  "settings.pwaIosSteps": "اضغط على مشاركة ← إضافة إلى الشاشة الرئيسية.",
  "settings.saveProfile": "حفظ الملف الشخصي",
  "settings.storedLocally": "يتم تخزين الإعدادات محليًا حتى تتوفر مزامنة الملف الشخصي.",
  "settings.weeklyEmailSummary": "ملخص أسبوعي عبر البريد الإلكتروني",
  "users.applicationDetails": "تفاصيل الطلب",
  "users.applicationReview": "مراجعة الطلب:",
  "users.applicationStatus": "حالة الطلب",
  "users.approve": "موافقة",
  "users.approveApplication": "الموافقة على الطلب",
  "users.backToApplications": "العودة إلى الطلبات",
  "users.colApplicant": "مقدم الطلب",
  "users.colRole": "الدور",
  "users.dateAdded": "تاريخ الإضافة",
  "users.directoryFound": "تم العثور عليه في جدول employees_personal_info.",
  "users.directoryMatch": "تطابق في الدليل",
  "users.directoryName": "الاسم في الدليل",
  "users.email": "البريد الإلكتروني",
  "users.filterAll": "جميع الطلبات",
  "users.filterPending": "بانتظار المراجعة",
  "users.nextSteps": "الخطوات التالية",
  "users.noApplications": "لم يتم العثور على طلبات",
  "users.phone": "الهاتف",
  "users.phoneNumber": "رقم الهاتف",
  "users.reject": "رفض",
  "users.rejectApplication": "رفض الطلب",
  "users.requestedRole": "الدور المطلوب",
  "users.review": "مراجعة",
  "users.statusRejected": "مرفوض",
  "users.stepBackgroundCheck": "بدء التحقق من الخلفية",
  "users.stepCheckLicense": "التحقق من صلاحية الترخيص/الشهادة",
  "users.stepScheduleInterview": "تحديد موعد المقابلة في حال الموافقة",
  "users.stepVerifyReferences": "التحقق من المراجع عبر الهاتف",
  "users.submitted": "تم الإرسال:",
  "widget.aiSummary": "ملخص بالذكاء الاصطناعي",
  "widget.barChart": "مخطط شريطي",
  "widget.comparison": "مقارنة",
  "widget.dataTable": "جدول بيانات",
  "widget.dayOfWeek": "يوم الأسبوع",
  "widget.image": "صورة",
  "widget.kpiRow": "صف مؤشرات الأداء",
  "widget.lineChart": "مخطط خطي",
  "widget.metricCard": "بطاقة مقياس",
  "widget.pieDonut": "دائري / حلقي",
  "widget.rankedTable": "جدول مرتّب",
  "widget.textBlock": "كتلة نص",

  // Activity calendar
  "calendar.title": "تقويم نشاط الدوريات",
  "calendar.subtitle": "نشاط المسح في كل نقطة تفتيش، يوماً بيوم",
  "calendar.viewMonth": "شهر",
  "calendar.viewWeek": "أسبوع",
  "calendar.viewDay": "يوم",
  "calendar.viewList": "قائمة",
  "calendar.today": "اليوم",
  "calendar.allHospitals": "كل المستشفيات",
  "calendar.totalScans": "{n} عملية مسح",
  "calendar.activeDays": "{n} يوماً نشطاً",
  "calendar.alertsCount": "{n} تنبيهات",
  "calendar.noActivityRange": "لا يوجد نشاط مسح في هذه الفترة.",
  "calendar.loading": "جارٍ تحميل النشاط…",
  "calendar.loadFailed": "فشل تحميل النشاط",
  "calendar.refresh": "تحديث",
  "calendar.colTime": "الوقت",
  "calendar.colHospital": "المستشفى",
  "calendar.colCheckpoint": "نقطة التفتيش",
  "calendar.colDevice": "الجهاز",
  "calendar.colGuard": "الحارس",
  "calendar.violation": "مخالفة",
  "calendar.violationsCount": "{n} مخالفات",
  "calendar.scansShort": "{n} عملية مسح",
  "calendar.hospitalsActive": "{n} مستشفيات نشطة",
  "calendar.moreEvents": "+{n} المزيد",
  "calendar.weekOf": "أسبوع {date}",
  "calendar.dayEvents": "أحداث المسح",
  "calendar.hourlyDistribution": "التوزيع حسب الساعة",
  "calendar.legendLess": "أقل",
  "calendar.legendMore": "أكثر",
  "calendar.unknownHospital": "مستشفى غير معروف",
  "calendar.unknownGuard": "حارس غير معروف",
  "calendar.unknownCheckpoint": "نقطة تفتيش غير معروفة",

  // --- Synced from en.ts: newer pages (officers, compliance, checkpoints, patrol reports) ---
  "nav.compliance": "الامتثال",
  "nav.officers": "الضباط",
  "nav.patrolReports": "تقارير الدوريات",
  "common.retry": "إعادة المحاولة",
  "common.collapse": "طيّ",
  "common.expand": "توسيع",
  "home.comparisonVsMapNote": "تشمل الأعداد كل عملية مسح مُسجَّلة. أما خريطة المسح فتعرض فقط عمليات المسح المزوَّدة بإحداثيات GPS، لذا قد يكون إجماليها أقل.",
  "live.colOfficer": "الضابط",
  "live.unattributed": "غير منسوب",
  "map.trailNote": "تُلوَّن النقاط حسب وقت المسح. لا يُرسَم أي مسار بين عمليات المسح — تُعرض مواقع المسح المُسجَّلة فقط.",
  "checkpoints.directoryTitle": "دليل نقاط التفتيش",
  "checkpoints.directorySubtitle": "كل نقطة تفتيش QR مسجَّلة، مرتّبة حسب الطابق",
  "checkpoints.searchPlaceholder": "ابحث بالاسم أو الرمز أو المبنى…",
  "checkpoints.countShown": "{n} نقطة تفتيش",
  "checkpoints.exportCsv": "تصدير CSV",
  "checkpoints.loadingDirectory": "جارٍ تحميل نقاط التفتيش…",
  "checkpoints.empty": "لم يتم العثور على نقاط تفتيش لهذا المستشفى.",
  "checkpoints.noFloor": "غير مخصّص",
  "checkpoints.floorLabel": "الطابق {n}",
  "checkpoints.colCode": "الرمز",
  "checkpoints.colName": "الاسم",
  "checkpoints.colBuilding": "المبنى",
  "checkpoints.colFloor": "الطابق",
  "checkpoints.colLastScanned": "آخر مسح",
  "checkpoints.colTotalScans": "إجمالي عمليات المسح",
  "checkpoints.colStatus": "الحالة",
  "checkpoints.active": "نشط",
  "checkpoints.inactive": "غير نشط",
  "checkpoints.never": "أبدًا",
  "checkpoints.untitled": "نقطة تفتيش بلا عنوان",
  "checkpoints.totalScans": "إجمالي عمليات المسح",
  "checkpoints.compliance": "الامتثال",
  "checkpoints.late": "متأخر",
  "checkpoints.missed": "فائت",
  "checkpoints.fromDate": "من",
  "checkpoints.toDate": "إلى",
  "checkpoints.clearDates": "مسح",
  "checkpoints.loadingHistory": "جارٍ تحميل سجل المسح…",
  "checkpoints.noScans": "لا توجد عمليات مسح مُسجَّلة لنقطة التفتيش هذه ضمن النطاق المحدد.",
  "checkpoints.unknownDevice": "جهاز غير معروف",
  "checkpoints.noGps": "لا يوجد GPS",
  "checkpoints.statusOnTime": "في الوقت المحدد",
  "checkpoints.statusLate": "متأخر",
  "checkpoints.statusMissed": "فائت",
  "checkpoints.viewHistory": "عرض سجل المسح",
  "compliance.title": "امتثال الدوريات",
  "compliance.subtitle": "حالة مسح نقاط التفتيش مقارنةً بالفاصل الزمني المُهيّأ لكل موقع.",
  "compliance.advisory": "لأغراض المعلومات فقط. يعرض هذا القسم وقت آخر مسح لكل نقطة تفتيش والوقت المتبقي في فاصلها الزمني للمسح. وهو ليس تكليفًا بعمل ولا مسارًا ولا تعليمًا. ويبقى تحديد نقاط التفتيش التي تُمسح وترتيبها من قرار الضابط ومشرفه، وفقًا لأوامر الموقع الصادرة عن جهة العمل وأي واجبات ذات أولوية أعلى.",
  "compliance.loadFailed": "تعذّر تحميل حالة الامتثال",
  "compliance.overdue": "متأخر",
  "compliance.overdueSub": "تجاوز الفاصل الزمني للمسح",
  "compliance.dueSoon": "يستحق قريبًا",
  "compliance.dueSoonSub": "في الربع الأخير من الفاصل الزمني",
  "compliance.onInterval": "ضمن الفاصل الزمني",
  "compliance.onIntervalSub": "تم المسح ضمن الفاصل الزمني",
  "compliance.neverScanned": "لا يوجد مسح مُسجَّل",
  "compliance.neverScannedSub": "لا يُحتسب كمتأخر",
  "compliance.neverScannedNoteTitle": "لماذا لا تُحتسب هذه كمتأخرة:",
  "compliance.neverScannedNote": "نقطة التفتيش التي ليس لها مسح مُسجَّل ليس لديها فاصل زمني يمكن تجاوزه. وتظهر نقاط التفتيش التي تسبق بدء تتبع الامتثال بهذا الشكل إلى أن تُنفَّذ عملية تعبئة البيانات التاريخية للموقع، لذا فإن اعتبارها متأخرة سيُطلق تنبيهًا لكل نقطة تفتيش دفعةً واحدة.",
  "compliance.openAlerts": "تنبيهات الامتثال المفتوحة",
  "compliance.checkpointStatus": "حالة نقاط التفتيش",
  "compliance.filterAttention": "المتأخرة والمستحقة قريبًا",
  "compliance.filterOverdue": "المتأخرة فقط",
  "compliance.filterAll": "جميع نقاط التفتيش",
  "compliance.emptyAll": "لم يتم العثور على نقاط تفتيش لهذا التحديد.",
  "compliance.emptyAttention": "لا توجد نقاط تفتيش متأخرة أو مستحقة قريبًا.",
  "compliance.colCheckpoint": "نقطة التفتيش",
  "compliance.colStatus": "الحالة",
  "compliance.colLastScan": "آخر مسح",
  "compliance.colInterval": "الفاصل الزمني",
  "compliance.colRemaining": "الوقت ضمن الفاصل الزمني",
  "compliance.colScans24h": "عمليات المسح (24 ساعة)",
  "compliance.status.OVERDUE": "متأخر",
  "compliance.status.DUE_SOON": "يستحق قريبًا",
  "compliance.status.OK": "ضمن الفاصل الزمني",
  "compliance.status.NEVER_SCANNED": "لا يوجد مسح مُسجَّل",
  "compliance.minutesShort": "دقيقة",
  "compliance.perDay": "في اليوم",
  "compliance.ruleLocation": "قاعدة الموقع",
  "compliance.ruleHospital": "الإعداد الافتراضي للموقع",
  "compliance.truncated": "عرض النتائج الأكثر إلحاحًا من حيث الوقت فقط. ضيّق النطاق حسب الموقع لرؤية البقية.",
  "compliance.generatedAt": "الحالة اعتبارًا من",
  "compliance.rules": "فواصل المسح الزمنية",
  "compliance.rulesTitle": "فواصل المسح الزمنية",
  "compliance.rulesSubtitle": "تتجاوز قاعدة الموقع الإعداد الافتراضي للموقع، الذي يتجاوز بدوره الإعداد الافتراضي للنظام.",
  "compliance.rulesEmpty": "لا توجد قواعد مخصصة — يُطبَّق الإعداد الافتراضي للنظام.",
  "compliance.rulesLoadFailed": "تعذّر تحميل القواعد",
  "compliance.rulesSaveFailed": "تعذّر حفظ القاعدة",
  "compliance.rulesDeleteFailed": "تعذّر حذف القاعدة",
  "compliance.rulesCreateFailed": "تعذّر إنشاء القاعدة",
  "compliance.rulesInvalid": "يجب أن يكون الفاصل الزمني والحد الأدنى اليومي أرقامًا",
  "compliance.systemDefault": "الإعداد الافتراضي للنظام",
  "compliance.systemDefaultValue": "كل",
  "compliance.systemDefaultNote": "تُقاس المواقع التي ليست لها قاعدة خاصة بها بناءً على هذا.",
  "compliance.siteWide": "جميع نقاط التفتيش في هذا الموقع",
  "compliance.colAppliesTo": "ينطبق على",
  "compliance.colIntervalMin": "الفاصل الزمني (دقيقة)",
  "compliance.colMinPerDay": "الحد الأدنى / 24 ساعة",
  "compliance.colActions": "الإجراءات",
  "compliance.addSiteDefault": "إضافة إعداد افتراضي للموقع",
  "compliance.pickSiteToAdd": "اختر موقعًا واحدًا لإضافة إعداد افتراضي له.",
  "officers.title": "الضباط",
  "officers.subtitle": "الضباط الذين يسجّلون الحضور برقم N لتُنسب عمليات المسح إليهم. هذه ليست حسابات دخول للوحة التحكم.",
  "officers.add": "إضافة ضابط",
  "officers.addTitle": "إضافة ضابط",
  "officers.editTitle": "تعديل ضابط",
  "officers.loadFailed": "تعذّر تحميل الضباط",
  "officers.saveFailed": "تعذّر حفظ الضابط",
  "officers.deactivateFailed": "تعذّر إلغاء تنشيط الضابط",
  "officers.searchPlaceholder": "ابحث بالاسم أو رقم N أو البريد الإلكتروني",
  "officers.filterActive": "نشط",
  "officers.filterInactive": "غير نشط",
  "officers.filterSuspended": "موقوف",
  "officers.filterPending": "بانتظار الموافقة",
  "officers.filterRejected": "مرفوض",
  "officers.filterAll": "جميع الحالات",
  "officers.onShiftCount": "المسجّلون حاليًا:",
  "officers.empty": "لا يوجد ضباط بعد. أضف ضابطًا لبدء نسب عمليات المسح.",
  "officers.emptySearch": "لا يوجد ضباط مطابقون لهذا البحث.",
  "officers.colOfficer": "الضابط",
  "officers.colNNumber": "رقم N",
  "officers.colSite": "الموقع",
  "officers.colStatus": "الحالة",
  "officers.colShift": "الوردية الحالية",
  "officers.colActions": "الإجراءات",
  "officers.status.ACTIVE": "نشط",
  "officers.status.PENDING": "بانتظار الموافقة",
  "officers.status.INACTIVE": "غير نشط",
  "officers.status.SUSPENDED": "موقوف",
  "officers.status.REJECTED": "مرفوض",
  "officers.onShiftSince": "بدأ منذ",
  "officers.offShift": "لم يسجّل الحضور",
  "officers.scans": "عمليات مسح",
  "officers.deactivate": "إلغاء التنشيط",
  "officers.deactivateTitle": "إلغاء تنشيط الضابط؟",
  "officers.deactivateBody": "لن يتمكن {name} بعد الآن من تسجيل الحضور، وسيتم إغلاق أي وردية مفتوحة. يُحتفظ بسجل مسحه ويبقى منسوبًا إليه.",
  "officers.fieldNNumber": "رقم N",
  "officers.fieldNNumberHint": "يُضاف حرف N في البداية تلقائيًا إذا أغفلته.",
  "officers.fieldName": "الاسم الكامل",
  "officers.fieldSite": "الموقع",
  "officers.fieldEmail": "البريد الإلكتروني",
  "officers.fieldPhone": "الهاتف",
  "officers.fieldStatus": "الحالة",
  "officers.fieldStatusHint": "الضباط النشطون فقط يمكنهم تسجيل الحضور. تغيير الحالة من «نشط» يُغلق أي وردية مفتوحة.",
  "officers.selectSite": "اختر موقعًا",
  "officers.formRequired": "رقم N والاسم والموقع مطلوبة",
  "officers.pendingTitle": "موافقات التسجيل المعلقة",
  "officers.selfEnrolled": "مُسجَّل ذاتيًا",
  "officers.enrolledAt": "سجّل الحضور",
  "officers.enrollDistance": "{d} عن منطقة المسح المُسجَّلة للموقع",
  "officers.enrollNoGps": "لا يوجد تحديد GPS عند تسجيل الحضور",
  "officers.enrollSiteMismatch": "تم اختيار {chosen}، لكن GPS أشار إلى {gps} — تأكّد من الصحيح قبل الموافقة.",
  "officers.pendingNote": "أُبلغ عن هذه الهويات ذاتيًا عند مسح البطاقة. تُنسب عمليات مسحهم مبدئيًا حتى الموافقة؛ ويحتفظ الرفض بالسجل وعمليات مسحه للمراجعة.",
  "officers.approve": "موافقة",
  "officers.reject": "رفض",
  "officers.approveTitle": "الموافقة على التسجيل؟",
  "officers.approveBody": "يؤكّد {n} كضابط في {site}. تبقى عمليات مسحه المعلقة منسوبة إليه، وتعمل عمليات تسجيل الحضور المستقبلية كالمعتاد.",
  "officers.approveName": "اسم الضابط (كما يجب أن يظهر)",
  "officers.approveFailed": "تعذّرت الموافقة على التسجيل",
  "officers.rejectFailed": "تعذّر رفض التسجيل",
  "patrolReports.title": "تقارير الدوريات",
  "patrolReports.subtitle": "نشاط الدوريات المُسجَّل حسب الضابط، وتغطية نقاط التفتيش، وسجل تنبيهات الامتثال.",
  "patrolReports.tabOfficers": "الضباط",
  "patrolReports.tabCoverage": "التغطية",
  "patrolReports.tabHistory": "سجل التنبيهات",
  "patrolReports.loadFailed": "تعذّر تحميل التقرير",
  "patrolReports.badRange": "يجب أن يكون تاريخ البدء في تاريخ الانتهاء أو قبله",
  "patrolReports.startDate": "تاريخ البدء",
  "patrolReports.endDate": "تاريخ الانتهاء",
  "patrolReports.totalScans": "عمليات المسح في الفترة",
  "patrolReports.attributed": "منسوبة إلى ضابط",
  "patrolReports.unattributed": "غير منسوبة",
  "patrolReports.unattributedSub": "مُسِحت بينما لم يكن أي ضابط مسجّلاً للحضور",
  "patrolReports.officersListed": "الضباط المدرجون",
  "patrolReports.noOfficers": "لا يوجد ضباط في هذا التحديد.",
  "patrolReports.colOfficer": "الضابط",
  "patrolReports.colSite": "الموقع",
  "patrolReports.colShifts": "الورديات",
  "patrolReports.colShiftTime": "وقت الوردية",
  "patrolReports.colScans": "عمليات المسح",
  "patrolReports.colCheckpoints": "نقاط التفتيش",
  "patrolReports.colScansHr": "عمليات المسح / ساعة",
  "patrolReports.colLastScan": "آخر مسح",
  "patrolReports.fullyCovered": "مُغطّاة كل يوم",
  "patrolReports.partiallyCovered": "مُغطّاة بعض الأيام",
  "patrolReports.uncovered": "لا عمليات مسح في الفترة",
  "patrolReports.of": "من",
  "patrolReports.coverageTitle": "تغطية نقاط التفتيش",
  "patrolReports.coverageSort": "نقاط التفتيش الأقل تغطيةً أولًا.",
  "patrolReports.colCheckpoint": "نقطة التفتيش",
  "patrolReports.colDaysCovered": "الأيام المُغطّاة",
  "patrolReports.colExpected": "المتوقّع",
  "patrolReports.colStatusNow": "الحالة الآن",
  "patrolReports.alertsRaised": "التنبيهات في الفترة",
  "patrolReports.alertsOpen": "ما زالت مفتوحة",
  "patrolReports.alertsResolved": "تم حلها",
  "patrolReports.repeatTitle": "نقاط التفتيش الأكثر إطلاقًا للتنبيهات",
  "patrolReports.colAlerts": "التنبيهات",
  "patrolReports.colOpen": "مفتوحة",
  "patrolReports.colWorst": "أسوأ تأخّر",
  "patrolReports.colAvgResolve": "متوسط وقت الحل",
  "patrolReports.colLatest": "الأحدث",
  "patrolReports.alertLog": "سجل التنبيهات",
  "patrolReports.noAlerts": "لا توجد تنبيهات في هذه الفترة.",
  "patrolReports.resolvedIn": "حُلّ خلال",
  "patrolReports.stateResolved": "تم الحل",
  "patrolReports.stateOpen": "مفتوح",
  "emailPrefs.title": "تفضيلات تنبيهات البريد الإلكتروني",
  "emailPrefs.subtitle": "اختر رسائل الامتثال التي تتلقاها عبر البريد الإلكتروني، لكل موقع.",
  "emailPrefs.loadFailed": "تعذّر تحميل تفضيلات البريد الإلكتروني",
  "emailPrefs.saveFailed": "تعذّر حفظ التفضيل",
  "emailPrefs.noSites": "لا توجد مواقع في قائمة وصولك.",
  "emailPrefs.noPreference": "لم يُحفظ أي تفضيل — يُطبَّق الإعداد الاحتياطي",
  "emailPrefs.explainer": "المواقع التي لم يحفظ فيها أحد أي تفضيل تعود إلى إرسال البريد الإلكتروني إلى جميع المشرفين والمديرين. حفظ أي تفضيل في موقع ما يحوّله إلى الخيارات المحددة صراحةً فقط.",
  "emailPrefs.overdue": "تنبيهات التأخّر",
  "emailPrefs.overdueHint": "بريد إلكتروني فوري عندما تتجاوز نقاط التفتيش فاصلها الزمني للمسح",
  "emailPrefs.daily": "الموجز اليومي",
  "emailPrefs.dailyHint": "ملخص امتثال واحد يوميًا",
  "emailPrefs.officerSummary": "ملخص نشاط الضباط",
  "emailPrefs.officerSummaryHint": "تقرير أسبوعي بالنشاط المُسجَّل. مُعطَّل ما لم تختر الاشتراك.",
  "emailPrefs.manageOthers": "إدارة المستلمين في هذا الموقع",
  "emailPrefs.noOthers": "لا يوجد مستلمون آخرون مُهيَّؤون هنا.",
  "emailPrefs.enrollEmail": "email@emoryhealthcare.org",
  "emailPrefs.enrollName": "الاسم (اختياري)",
  "emailPrefs.enroll": "إضافة مستلم",
  "emailPrefs.officerSummaryNote": "ملخص نشاط الضباط هو تقرير مُجدوَل لنشاط المسح المُسجَّل مع تحفظاته — وهو ليس درجة أداء، ولا يُرسَل أبدًا إلى أي شخص لم يشترك فيه.",
  "officerMap.open": "عرض خريطة سجل المسح",
  "officerMap.title": "سجل المسح",
  "officerMap.loadFailed": "تعذّر تحميل سجل المسح",
  "officerMap.empty": "لا توجد عمليات مسح موسومة بـ GPS منسوبة إلى هذا الضابط في الفترة المحددة.",
  "officerMap.firstScan": "أول مسح",
  "officerMap.lastScan": "آخر مسح",
  "officerMap.scans": "عمليات مسح",
  "officerMap.ofTotal": "من {n} عملية مسح",
  "officerMap.note": "تظهر هنا فقط عمليات المسح المنسوبة إلى هذا الضابط. أما عمليات المسح التي تُجرى دون تسجيل الحضور فتكون غير منسوبة ولا تُعرض.",
  "patrolReports.officersTableTitle": "النشاط المُسجَّل حسب الضابط",


  // --- Officer detail page (synced from en.ts) ---
  "officerDetail.allOfficers": "جميع الضباط",
  "officerDetail.backToOfficers": "العودة إلى الضباط",
  "officerDetail.notFound": "لم يتم العثور على الضابط.",
  "officerDetail.loadFailed": "تعذّر تحميل الضابط",
  "officerDetail.selfEnrolled": "مُسجَّل ذاتيًا",
  "officerDetail.addedBySupervisor": "أضافه المشرف",
  "officerDetail.memberSince": "عضو منذ {date}",
  "officerDetail.totalScans": "إجمالي عمليات المسح",
  "officerDetail.shifts": "الورديات",
  "officerDetail.activeDays": "الأيام النشطة",
  "officerDetail.avgShift": "المتوسط / وردية",
  "officerDetail.noShiftsYet": "لا توجد ورديات بعد",
  "officerDetail.scansPerShift": "عمليات مسح لكل وردية",
  "officerDetail.lastActive": "آخر نشاط",
  "officerDetail.whereScanned": "أين مسح {name}",
  "officerDetail.mapToLight": "تبديل الخريطة إلى المربّعات الفاتحة",
  "officerDetail.mapToDark": "تبديل الخريطة إلى المربّعات الداكنة",
  "officerDetail.light": "فاتح",
  "officerDetail.dark": "داكن",
  "officerDetail.noGpsScans": "لا توجد عمليات مسح موسومة بـ GPS لعرضها على الخريطة في آخر 30 يومًا.",
  "officerDetail.scanActivityTitle": "نشاط المسح — آخر {n} يومًا",
  "officerDetail.noScansInDays": "لا توجد عمليات مسح مُسجَّلة في آخر {n} يومًا.",
  "officerDetail.scanHistory": "سجل المسح",
  "officerDetail.searchScans": "ابحث في عمليات المسح…",
  "officerDetail.colDateTime": "التاريخ والوقت",
  "officerDetail.colLocation": "الموقع",
  "officerDetail.colHospital": "المستشفى",
  "officerDetail.colCoordinates": "الإحداثيات",
  "officerDetail.noScansMatch": "لا توجد عمليات مسح تطابق “{q}”.",
  "officerDetail.showingScans": "عرض {shown} من أصل {total} عملية مسح مُسجَّلة (آخر 30 يومًا).",
  "officerDetail.timelineRange": "{n} عملية مسح · الأقدم ← الأحدث",
  "officerDetail.hoverTimeline": "مرّر المؤشر على الخط الزمني لتتبّع عملية مسح",
  "officerDetail.timelineCaption": "كل نقطة تمثل عملية مسح واحدة، موضوعة حسب وقت حدوثها ومُلوَّنة من الأزرق للأقدم إلى الأحمر للأحدث. مرّر المؤشر لإبرازها على الخريطة. لا يُرسَم أي مسار بين عمليات المسح — تُعرض مواقع المسح المُسجَّلة فقط.",


  // --- Scan Map anomaly/misplaced views (synced from en.ts) ---
  "map.officer": "الضابط",
  "map.clearOfficer": "مسح تصفية الضابط",
  "map.searchOfficer": "ابحث عن ضابط…",
  "map.misplacedTitle": "عرض عمليات المسح التي وقع تحديد GPS لها على بُعد أكثر من كيلومتر واحد من نقطة تفتيشها فقط",
  "map.misplacedOn": "في غير موضعها",
  "map.misplacedOff": "في غير موضعها",
  "map.anomaliesTitle": "عرض عمليات المسح المُعلَّمة كشاذة — تنقّل مستحيل للضابط، أو عملية مسح مرسومة بعيدًا عن مستشفاها",
  "map.anomalies": "الحالات الشاذة",
  "map.popupOfficer": "الضابط:",
  "map.anomalousMovement": "شاذة — تنقّل مستحيل بين عمليات مسح هذا الضابط",
  "map.anomalousHospital": "شاذة — مرسومة بعيدًا عن المستشفى المُسمّى لها",
  "map.anomalousBoth": "شاذة — تنقّل مستحيل وبعيدة عن مستشفاها",
  "map.metersFromCheckpoint": "{n} م عن نقطة تفتيشها",
  "map.scansLabel": "عمليات مسح",
  "map.earliest": "الأقدم",
  "map.latest": "الأحدث",

};

export default ar;
